import { alertController } from '@ionic/core';
import { BaseDoc } from 'common';

export class SharedUtils {
  static scrollToBottom(ref: HTMLDivElement, delay = 100): void {
    if (ref) {
      setTimeout(() => {
        ref.scrollTop = ref.scrollHeight;
      }, delay);
    }
  }

  static async filterAndValidateUploads(files: FileList, currentUploads: File[]): Promise<File[]> {
    const allowedTypes = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.csv', '.jpg', '.jpeg', '.png', '.gif', '.webp'];
    const validFiles = Array.from(files).filter(file => {
      const extension = '.' + file.name.split('.').pop().toLowerCase();
      return allowedTypes.includes(extension);
    });
    if (validFiles.length !== files.length) {
      const alert = await alertController.create({
        header: 'Invalid File Type',
        message: 'Only PDF, Word documents, Excel spreadsheets, and common image formats are allowed.',
        buttons: ['OK'],
      });
      await alert.present();
    }
    return [...currentUploads, ...validFiles];
  }

  static upsertArrayUtil<T extends { _id: string } | { id: string }>(targetArray: T[], itemsToUpsert: T[]): T[] {
    // filter out deleted items
    const result = [...targetArray];

    const getId = (item: T): string => {
      return '_id' in item ? item._id : (item as { id: string }).id;
    };

    itemsToUpsert.forEach(item => {
      const itemId = getId(item);
      const index = result.findIndex(existingItem => getId(existingItem) === itemId);

      if (index !== -1) {
        result[index] = { ...result[index], ...item };
      } else {
        result.push(item);
      }
    });

    return result;
  }

  static capitalizeText(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
